import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';
import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';

export const ButtonLoadingDefaultProps = {
  ...BaseDefaultProps,
  ...ChildrenDefaultProps,
  context: null,
  buttonSize: 'large',
  fontSize: 'medium',
  onClick: () => {},
  type: 'submit',
  variant: 'primary',
  value: null,
  withIcon: false,
};

export const ButtonLoadingPropTypes = {
  ...BasePropTypes,
  ...ChildrenPropTypes,
  context: PropTypes.string,
  buttonSize: PropTypes.string,
  fontSize: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']), // TODO: to put in config
  variant: PropTypes.string,
  value: PropTypes.string,
  withIcon: PropTypes.bool,
};
